import type { ReactNode } from 'react';

interface PublicOrderActionButtonProps {
  onClick: () => void;
  icon: ReactNode;
  label: string;
  sub: string;
  disabled?: boolean;
  accent?: boolean;
}

export function PublicOrderActionButton({
  onClick,
  icon,
  label,
  sub,
  disabled,
  accent,
}: PublicOrderActionButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center gap-2 px-3 py-2 rounded-xl border transition-all w-full
        active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed
        ${accent
          ? 'bg-blue-600 border-blue-600 text-white hover:bg-blue-700 hover:border-blue-700'
          : 'bg-white border-slate-200 text-slate-700 hover:border-blue-400 hover:bg-blue-50/40 hover:text-blue-700'
        }
      `}
    >
      <span className={accent ? 'text-white' : 'text-slate-400 group-hover:text-blue-500'}>{icon}</span>
      <div className="flex flex-col items-start leading-none">
        <span className="text-[12px] font-bold">{label}</span>
        <span
          className={`text-[9px] font-semibold uppercase tracking-wide mt-0.5 ${
            accent ? 'text-blue-200' : 'text-slate-400'
          }`}
        >
          {sub}
        </span>
      </div>
    </button>
  );
}

